import {
  Box,
  Typography,
  Container,
  Grid,
  Stack,
} from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import ElectricBoltIcon from "@mui/icons-material/ElectricBolt";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import PeopleIcon from "@mui/icons-material/People";

function AboutUsPage() {
  const reliabilityFeatures = [
    {
      icon: <WorkspacePremiumIcon fontSize="large" />,
      title: "Premium-Grade Material Used",
      description:
        "The milling chamber, hopper, and grinding plates are crafted from food-grade stainless steel. This material is not only exceptionally durable and resistant to corrosion but also ensures that no contaminants or metallic tastes affect your flour",
    },
    {
      icon: <ElectricBoltIcon fontSize="large" />,
      title: "Powerful and Durable Motors",
      description:
        "Our flour mills are equipped with powerful, heavy-duty motors that are engineered for both performance and longevity. It's a motor that's built not just for power, but for unwavering reliability",
    },
    {
      icon: <VerifiedUserIcon fontSize="large" />,
      title: "Consistent and Uniform Grinding",
      description:
        "Our mills are engineered to deliver consistent and uniform grinding with every use. Precision-calibrated grinding stones or blades ensure that each grain is milled to your exact specifications, resulting in a fine, smooth flour",
    },
    {
      icon: <PeopleIcon fontSize="large" />,
      title: "Comprehensive Customer Support",
      description:
        "We offer a robust system of support and a comprehensive warranty to ensure you feel confident in your purchase from day one. We stand firmly behind the quality and performance of every mill we sell.",
    },
  ];
  return (
    <Box sx={{ background: "#fdfaf6" }}>
      {/* Hero Section */}
      <Box
        sx={{
          pt: 16,
          pb: 6,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background:
            "linear-gradient(rgba(255,255,255,0.7), rgba(255,255,255,0.7)), url(https://placehold.co/1800x200/F5F5F5/8D6E63?text=RIDHI+SIDHI)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          textAlign: "center",
          flexGrow: 1,
        }}
      >
        <Container maxWidth="md">
          <Typography
            component="h1"
            variant="h3"
            gutterBottom
            sx={{ color: "#4E342E" }}
          >
            WORLD's LEADING FLOUR MILL BRAND
          </Typography>
          <Typography variant="h4" paragraph sx={{ color: "#6D4C41" }}>
            Built on generations of trust and an unwavering commitment to
            quality.
          </Typography>
        </Container>
      </Box>

      {/* Our Story Section */}
      <Container sx={{ py: 8 }} maxWidth="md">
        <Stack spacing={2}>
          <Typography
            variant="h3"
            align="center"
            textTransform="uppercase"
            gutterBottom
            sx={{ background: "#fdfaf6", color: "#5D4037"  }}
          >
            Our Milling Heritage
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Our story isn't just about manufacturing flour mills, it's about a
            deep-rooted <strong>milling heritage</strong> that spans
            generations. We began with a simple yet profound vision: to provide
            every home with the means to enjoy fresh, wholesome flour, ground
            with care and precision. This vision was born from a rich tradition
            of understanding grains and the transformative process of milling.
          </Typography>
          <Typography variant="body1" color="text.secondary">
            From humble beginnings, our founders were driven by a passion for
            quality and a commitment to craftsmanship. They meticulously studied
            the mechanics of grinding, the nuances of different grains, and the
            enduring needs of households. This foundational knowledge, passed
            down through the years, became the bedrock of our operations. It's a
            heritage built on{" "}
            <strong>
              experience, dedication, and an unyielding pursuit of excellence
            </strong>
            .
          </Typography>
          <Typography variant="body1" color="text.secondary">
            As technology advanced, so did we. Yet, we never lost sight of the
            core principles inherited from our past. We integrated modern
            engineering and innovative designs, always ensuring that the spirit
            of traditional milling — that perfect balance of power and finesse —
            remained at the heart of our machines. Our heritage is a testament
            to adapting while preserving the essence of what makes a great flour
            mill.
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Today, this rich history empowers us. It informs our meticulous
            design process, guides our selection of premium materials, and fuels
            our rigorous quality control. It's why we don't just build
            appliances, we craft instruments that carry forward a legacy of
            freshness and nutritional value into your home. Our milling heritage
            isn't just history, it's the{" "}
            <strong>promise of reliability and authentic goodness</strong> in
            every grain you mill.
          </Typography>
        </Stack>
        {/* <Typography variant="body1" color="text.secondary">
                                {constants.ABOUT_US_CONTENT}
                            </Typography> */}
      </Container>

      {/* Reliability Section */}
      <Box sx={{ py: 8 }}>
        <Container maxWidth="lg">
          <Typography
            variant="h4"
            align="center"
            textTransform="uppercase"
            gutterBottom
            sx={{ mb: 6, color: "#5D4037" }}
          >
            Why You Can Rely On Us?
          </Typography>
          <Grid
            container
            spacing={4}
            sx={{ display: "flex", flexDirection: "row" }}
          >
            {reliabilityFeatures.map((feature) => (
              <Grid
                item
                key={feature.title}
                xs={12} sm={6} md={3} lg={3}
              >
                <Card
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "center",
                    p: 2,
                    borderRadius: 2,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                    background: "#ffffff",
                  }}
                >
                  <Box sx={{ mb: 2 }}>{feature.icon}</Box>
                  <CardContent>
                    <Typography
                      gutterBottom
                      variant="h5"
                      component="h2"
                      sx={{ color: "#A1887F" }}
                    >
                      {feature.title}
                    </Typography>
                    <Typography color="text.secondary">
                      {feature.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Team Section */}
      {/* <Container sx={{ py: 8 }} maxWidth="md">
                            <Typography variant="h4" align="center" gutterBottom sx={{ mb: 6, color: '#5D4037' }}>
                                Meet the Hands Behind the Mill
                            </Typography>
                            <Grid container spacing={4} justifyContent="center">
                                {teamMembers.map((member) => (
                                <Grid item key={member.name} xs={12} sm={4} sx={{ textAlign: 'center' }}>
                                    <Avatar
                                        alt={member.name}
                                        src={member.avatar}
                                        sx={{ width: 100, height: 100, margin: '0 auto 16px', bgcolor: 'secondary.light' }}
                                    />
                                    <Typography variant="h6" sx={{ color: '#6D4C41' }}>{member.name}</Typography>
                                    <Typography color="text.secondary">{member.role}</Typography>
                                </Grid>
                                ))}
                            </Grid>
                        </Container>  */}

      {/* Footer */}
      {/* <Box sx={{ bgcolor: 'primary.main', p: 6, background: '#8d6e63' }} component="footer">
                        <Typography variant="h6" align="center" gutterBottom>
                            Golden Grain Flour Mill
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            align="center"
                            component="p"
                        >
                            Quality you can taste. Reliability you can trust.
                        </Typography>
                    </Box> */}
    </Box>
  );
}

export default AboutUsPage;
